import { Route } from 'react-router-dom';

import { RouteType } from './types';

const drawRoutes = (
  routes: RouteType[],
  company: Record<string, unknown> | undefined,
): ReactNode[] =>
  routes.map((route) => (
    <Route
      key={route.path}
      path={route.path}
      exact={route.exact}
      render={(props) => (
        <route.component {...props} company={company} routes={route.routes} />
      )}
    />
  ));

export default drawRoutes;
